export default "//static.tradera.net/touchweb/static/output/images/category-antiques-design.255734c4.svg";